module.exports = __webpack_public_path__ + "static/media/vivamind_logo.2e706150.png";